"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexFromWeekday = exports.weekdayFromIndex = exports.WeekdayStruct = exports.Week = void 0;
const superstruct_1 = require("superstruct");
exports.Week = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
exports.WeekdayStruct = (0, superstruct_1.enums)(exports.Week);
exports.WeekdayStruct.type = 'Weekday';
function weekdayFromIndex(dayIndex) {
    switch (Number(dayIndex)) {
        case 0:
            return 'SU';
        case 1:
            return 'MO';
        case 2:
            return 'TU';
        case 3:
            return 'WE';
        case 4:
            return 'TH';
        case 5:
            return 'FR';
        case 6:
            return 'SA';
        case 7:
            return 'SU';
        default:
            throw new Error(`Invalid day index: ${dayIndex}`);
    }
}
exports.weekdayFromIndex = weekdayFromIndex;
function indexFromWeekday(weekday) {
    switch (weekday) {
        case 'SU':
            return 0;
        case 'MO':
            return 1;
        case 'TU':
            return 2;
        case 'WE':
            return 3;
        case 'TH':
            return 4;
        case 'FR':
            return 5;
        case 'SA':
            return 6;
        //@ts-ignore - legacy support
        case 'ST':
            return 6;
        default:
            throw new Error(`Invalid weekday: ${weekday}`);
    }
}
exports.indexFromWeekday = indexFromWeekday;
//# sourceMappingURL=weekdays.js.map